module.exports = __webpack_public_path__ + "static/media/webdesign-services-img44.851a3d85.jpg";